<template lang="pug">
  div.wrap-item-counceling-radio
    v-radio-group(v-model="answer")
      span.block.bold.fz12.mb8 {{question}}
      div.f.flex-wrap
        v-radio(v-for="(n, i) in selection"
          :label="(i != selection.length - 1) ? `${n}${selectionUnit}` : `${n}${selectionUnit}${lastSelectionUnit}`"
          :value="n").mr8.mb8
</template>

<style lang="scss">
.wrap-item-counceling-radio {
  .v-input--selection-controls {
    margin: 0 !important;
  }
  .v-input--selection-controls__input {
    margin-right: 4px !important;
  }
}
</style>

<script>
import db from "@/components/utils/firebase"

import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")

export default {
  props: {
    question: {
      type: String,
      required: true
    },
    selection: {
      type: Array,
      required: true
    },
    defaultAnswer: {
      validator: v => true, // Any
      default: null
    },
    selectionUnit: {
      type: String,
      default: ""
    },
    lastSelectionUnit: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      answer: null
    }
  },
  watch: {
    defaultAnswer (val) {
      this.answer = this.defaultAnswer
    }
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  created () {
    if (this.defaultAnswer) this.answer = this.defaultAnswer
  },
  methods: {
    getAnswer () {
      return this.answer
    }
  }
}
</script>
